import { render, staticRenderFns } from "./ValidationPopup.vue?vue&type=template&id=455dfb02&scoped=true&"
import script from "./ValidationPopup.vue?vue&type=script&lang=js&"
export * from "./ValidationPopup.vue?vue&type=script&lang=js&"
import style0 from "./ValidationPopup.vue?vue&type=style&index=0&id=455dfb02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455dfb02",
  null
  
)

export default component.exports